/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_GoInputs */

const en_common_go = /** @type {(inputs: Common_GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go`)
};

const de_common_go = /** @type {(inputs: Common_GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los`)
};

const fr_common_go = /** @type {(inputs: Common_GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aller`)
};

const es_common_go = /** @type {(inputs: Common_GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir`)
};

const it_common_go = /** @type {(inputs: Common_GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai`)
};

const nl_common_go = /** @type {(inputs: Common_GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ga`)
};

const pl_common_go = /** @type {(inputs: Common_GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idź`)
};

const fi_common_go = /** @type {(inputs: Common_GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mene`)
};

const da_common_go = /** @type {(inputs: Common_GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gå`)
};

const sv_common_go = /** @type {(inputs: Common_GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gå`)
};

/**
* | output |
* | --- |
* | "Go" |
*
* @param {Common_GoInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const common_go = /** @type {((inputs?: Common_GoInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_GoInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_common_go(inputs)
	if (locale === "fr") return fr_common_go(inputs)
	if (locale === "es") return es_common_go(inputs)
	if (locale === "it") return it_common_go(inputs)
	if (locale === "nl") return nl_common_go(inputs)
	if (locale === "pl") return pl_common_go(inputs)
	if (locale === "fi") return fi_common_go(inputs)
	if (locale === "da") return da_common_go(inputs)
	if (locale === "sv") return sv_common_go(inputs)
	return en_common_go(inputs)
});